module.exports = __webpack_public_path__ + "img/logoBeron.185f241a.jpg";